import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useAuthStore } from './auth-store';

export function RequireAdminAuth() {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  const tenantSlug = useAuthStore((s) => s.tenantSlug);

  if (!slug) return <Navigate to="/" replace />;
  if (!isAuthenticated() || !user) {
    return <Navigate to={`/tenants/${slug}/login`} state={{ from: location.pathname }} replace />;
  }
  // tid drift guard: JWT was minted for a different tenant slug
  if (tenantSlug && tenantSlug !== slug) {
    useAuthStore.getState().logout();
    return <Navigate to={`/tenants/${slug}/login`} state={{ reason: 'tenant_switch' }} replace />;
  }
  if (user.mustChangePassword && !location.pathname.endsWith('/change-password')) {
    return <Navigate to={`/tenants/${slug}/change-password`} replace />;
  }
  return <Outlet />;
}
